const lastDrawer = {
  state: {
    drawer: null,
  },
  mutations: {
    setLastDrawer: (state, d) => {
      state.drawer = d
    },
    closeLastDrawer: (state) => {
      if (state.drawer) {
        state.drawer.drawerTaggle()
      }
    },
    clearLastDrawer: (state) => {
      if (state.drawer) {
        state.drawer = null
      }
    }
  },
  actions: {
  }
}

export default lastDrawer
